import UiRule from '@/Modules/Quote/Components/QuoteForm/UiRules/UiRule.js'
import QuoteEndorsementService from '@/Modules/Quote/QuoteEndorsement/QuoteEndorsementService.js'
import _ from 'lodash'

const ENDORSEMENT_GROUP_ACTIONS = Object.freeze(['setEndorsementGroup', 'updateEndorsementGroup'])
const INDEX_MACRO = '{0}'

export default class UiRuleAction {
  constructor(baseNode, resolver, quote, store) {
    this.baseNode = baseNode
    this.resolver = resolver
    this.quote = quote
    this.store = store
  }

  /**
   *
   * @param {object} rule
   * @returns {object} baseNode
   */
  execute() {
    throw new Error('You have to implement the method execute!')
  }

  /**
   * After unlinking an endorsement group, re-evaluate all setEndorsementGroup /
   * updateEndorsementGroup rules across the form and re-link any whose conditions
   * are currently met. The backend link call is idempotent (skips existing entries).
   *
   * @returns {Promise<void>}
   */
  async relinkActiveEndorsementGroups() {
    const traverse = async (node) => {
      if (!node?.properties || _.isEmpty(node.properties)) {
        return
      }

      for (const key in node.properties) {
        if (!Object.prototype.hasOwnProperty.call(node.properties, key)) {
          continue
        }

        const property = node.properties[key]

        if (_.isArray(property.uiRules)) {
          for (const rule of property.uiRules) {
            if (!ENDORSEMENT_GROUP_ACTIONS.includes(rule.action)) {
              continue
            }

            const uiRule = new UiRule(rule)
            const conditionMet = !uiRule.condition || this.resolver.evaluateCondition(uiRule)

            if (!conditionMet) {
              continue
            }

            const value = this.resolver.getValueBySourceOrParameters(rule)
            let section = _.isObject(uiRule.target) ? uiRule.target.section : uiRule.target

            if (section?.includes(INDEX_MACRO) && uiRule.actualKey) {
              section = section.replace(INDEX_MACRO, uiRule.actualKey)
            }

            try {
              await QuoteEndorsementService.linkEndorsementsGroup(this.quote.id, section, value)
            } catch (error) {
              console.error(error)
            }
          }
        }

        await traverse(property)
      }
    }

    await traverse(this.baseNode)
  }
}
